import React from 'react';
import { Smartphone, UserCheck, CreditCard, ClipboardList } from 'lucide-react';

const actions = [
  {
    title: 'Selvbetjening',
    description: 'Bestil tid, forny recepter og skriv til lægen direkte via vores portal.',
    icon: UserCheck,
    cta: 'Gå til selvbetjening',
    href: 'https://www.besoeglaegen.dk/Login.aspx?ClinicId=009555',
    color: 'bg-white',
    textColor: 'text-slate-900',
    descColor: 'text-slate-600',
    iconColor: 'text-slate-900',
    borderColor: 'border-slate-900',
    hoverColor: 'hover:text-slate-700',
    shadow: 'shadow-xl z-10'
  },
  {
    title: 'MinLæge App',
    description: 'Få adgang til din læge direkte fra mobilen. Hurtigt, nemt og sikkert.',
    icon: Smartphone,
    cta: 'Læs om appen',
    href: 'https://minlaegeapp.dk/',
    color: 'bg-[#4b717a]',
    textColor: 'text-white',
    descColor: 'text-slate-100',
    iconColor: 'text-white',
    borderColor: 'border-white',
    hoverColor: 'hover:text-slate-200',
    shadow: ''
  }
];

export default function QuickActions() {
  return (
    <section className="relative z-20 mt-0 md:-mt-20 md:max-w-7xl md:mx-auto px-0 md:px-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-0 shadow-none md:shadow-2xl">
        {actions.map((action, index) => (
          <div 
            key={action.title}
            className={`${action.color} ${action.textColor} ${action.shadow} p-10 md:p-16 flex flex-col items-start gap-6 group hover:scale-[1.02] transition-transform duration-500`}
          >
            <div className="w-16 h-16 flex items-center justify-center mb-2">
              <action.icon size={32} className={action.iconColor} />
            </div>
            <h3 className="text-3xl font-sans font-medium">{action.title}</h3>
            <p className={`${action.descColor} leading-relaxed max-w-sm`}>
              {action.description}
            </p>
            <a 
              href={action.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`mt-4 flex items-center gap-3 text-xs tracking-[0.3em] uppercase font-bold border-b ${action.borderColor} pb-2 ${action.hoverColor} transition-colors`}
            >
              {action.cta}
              <Smartphone size={14} />
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
